import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center relative overflow-hidden">
            {/* Background blobs are handled by ZenBackground in Layout, but this might be outside Layout? 
          If outside, we can add a local background. Assuming it's inside Layout for now or we add local one.
      */}

            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
                className="relative z-10 max-w-lg"
            >
                <div className="w-24 h-24 mx-auto bg-blue-50 dark:bg-blue-900/20 rounded-full flex items-center justify-center mb-6 animate-float">
                    <span className="text-4xl">🍃</span>
                </div>

                <h1 className="text-4xl md:text-5xl font-display font-bold text-gray-900 dark:text-white mb-4">
                    You seem closer to silence.
                </h1>

                <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                    The path you clicked on doesn't exist, but that's okay. <br />
                    Getting lost is often the first step to finding your way.
                </p>

                {/* Breathing Circle */}
                <div className="mb-10">
                    <p className="text-xs uppercase tracking-widest text-gray-400 mb-4">Breathe In • Breathe Out</p>
                    <div className="relative w-16 h-16 mx-auto">
                        <motion.div
                            animate={{ scale: [1, 1.5, 1] }}
                            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                            className="absolute inset-0 bg-brand-blue/20 rounded-full"
                        />
                        <motion.div
                            animate={{ scale: [1, 1.2, 1] }}
                            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                            className="absolute inset-0 bg-brand-blue/30 rounded-full scale-75"
                        />
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link
                        to="/dashboard"
                        className="flex items-center gap-2 px-6 py-3 bg-brand-blue text-white rounded-full font-medium hover:bg-blue-600 transition shadow-lg shadow-blue-500/20"
                    >
                        <Home className="w-4 h-4" /> Return Home
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="flex items-center gap-2 px-6 py-3 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-full font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                    >
                        <ArrowLeft className="w-4 h-4" /> Go Back
                    </button>
                </div>
            </motion.div>
        </div>
    );
}
